import { VariaveisAmbiente } from 'config';
import { ApiListModel } from 'model/api/gestao/api-list-model/api-list-model';
import { useCallback } from 'react';
import { useApiBase } from '../../base/api-base';
import { PessoaWhitelabelModel } from 'model/api/gestao/pessoa/pessoa-whitelabel-model';

export function useGetPessoaWhitelabel() {
    const { invocarApi, ...outrasPropriedades } = useApiBase<ApiListModel<PessoaWhitelabelModel>>();

    const getPessoaWhitelabel = useCallback(
        async (pessoaId: string, page: number, queryBusca: string) => {
            let queryPage = "";
            if (page) {
                queryPage = "page=" + page.toString();
            }
            const queryFinal = `${queryPage?.length > 0 || queryBusca?.length > 0 ? "?" : ""
                }${queryPage}${queryPage.length > 0 ? "&" : ""}${queryBusca}`;

            return invocarApi({
                url: `${VariaveisAmbiente.apiVersion}/pessoa/${pessoaId}/Whitelabel${queryFinal}`,
                method: 'GET',
                enviarTokenUsuario: true
            })
        }
        , [invocarApi]
    );
    return {
        ...outrasPropriedades,
        getPessoaWhitelabel,
    };
}
